import { Pagination, PaginationContent, PaginationItem, PaginationNext, PaginationPrevious } from '@/view/components/ui/pagination'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { convertParamsToJson, useCashfitParams } from '../hooks/use-params'

interface Props {
  data: any
  labelItem?: string
}

export function PaginationCashfit({ data, labelItem = '' }: Props) {
  const [params] = useSearchParams()
  const { getParam, setParams } = useCashfitParams(convertParamsToJson(params))

  const totalForPage = 10

  useEffect(() => {
    const page = data?.pageable?.pageNumber ?? 0
    const totalPages = data?.totalPages ?? 0
    const total = data?.totalElements ?? 0

    setParams({
      page,
      pageSize: totalForPage,
      totalContents: total,
      totalPages
    })
  }, [data])

  const backPage = () => {
    if (page === 0) return
    setParams({ page: page - 1 })
  }

  const nextPage = () => {
    if (page >= totalPages - 1) return
    setParams({ page: page + 1 })
  }

  const totalContent = Number(getParam('totalContents') || 0)
  const page = Number(getParam('page') || 0)
  const totalPages = Number(getParam('totalPages') || 0)

  const valueNow = totalForPage * (page + 1) > totalContent ? totalContent : totalForPage * (page + 1)
  return (
    <Pagination className="w-full flex justify-between items-center py-2 text-gray-500 ">
      <div className="px-2 text-sm text-gray-500">{`${valueNow} de ${getParam('totalContents')} ${labelItem}.`}</div>
      <PaginationContent>
        <PaginationItem className="cursor-pointer">
          <PaginationPrevious onClick={backPage}></PaginationPrevious>
        </PaginationItem>
        <PaginationItem className="mx-2">{page + 1}</PaginationItem>
        <PaginationItem className="cursor-pointer">
          <PaginationNext onClick={nextPage} />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
